/* =============================================================
   CB · CARA BONITA · V10 EDITORIAL AWARD
   Premium interactions: reveal, magnetic, drawer, faq,
   counter, parallax, sticky nav, scroll progress,
   editorial menu hover swap.
   ============================================================= */
(function () {
  'use strict';

var root=document.querySelector("[data-cb-home], [data-cb-treatments], [data-cb-clinic], [data-cb-resultados], [data-cb-tienda], [data-cb-blog], [data-cb-article]")
  if (!root) return;
  var isTreatments = root.hasAttribute('data-cb-treatments');

  // ---------- Kill orphan PageFly / 3rd-party sections after our home ----------
  if (document.body.classList.contains('template-index')) {
    var orphanSelectors = [
      '[id^="shopify-section-pagefly"]',
      '[id*="pagefly-home"]',
      '[data-pf-type]',
      '#pagefly-app'
    ];
    orphanSelectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (n) {
        n.style.display = 'none';
      });
    });
  }

  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---------- Reveal on scroll ----------
  var reveals = root.querySelectorAll('.cb-rv');
  if ('IntersectionObserver' in window && !prefersReduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (n) { io.observe(n); });
  } else {
    reveals.forEach(function (n) { n.classList.add('is-visible'); });
  }

  // ---------- Scroll visuals: one frame, all geometry reads before writes ----------
  var nav = root.querySelector('[data-cb-nav]');
  var heroScrollCue = root.querySelector('.cb-hero__scroll');
  var floatBtn = root.querySelector('[data-cb-float]');
  var hero = floatBtn ? root.querySelector('[data-cb-hero]') : null;
  var progressEl = root.querySelector('[data-cb-progress]');
  var scrollTicking = false;
  var parallaxRecords = [];
  var canObserveParallax = 'IntersectionObserver' in window;

  if (!prefersReduce) {
    root.querySelectorAll('[data-cb-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (img) parallaxRecords.push({ element: el, image: img, visible: !canObserveParallax });
    });
  }

  function updateScrollFrame() {
    scrollTicking = false;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var vh = window.innerHeight;
    var docH = progressEl ? document.documentElement.scrollHeight - vh : 0;
    var heroBottom = floatBtn && hero ? hero.getBoundingClientRect().bottom : 600;
    var progress = docH > 0 ? Math.min(1, Math.max(0, y / docH)) : 0;
    var parallaxUpdates = [];

    parallaxRecords.forEach(function (record) {
      if (!record.visible) return;
      var rect = record.element.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) return;
      var center = rect.top + rect.height / 2;
      var offset = (center - vh / 2) / vh;
      var translate = Math.max(-30, Math.min(30, -offset * 26));
      parallaxUpdates.push({ image: record.image, translate: translate });
    });

    if (nav) nav.classList.toggle('is-stuck', y > 24);
    if (heroScrollCue) heroScrollCue.style.opacity = Math.max(0, 1 - y / 240).toFixed(2);
    if (floatBtn) floatBtn.classList.toggle('is-visible', heroBottom < 0);
    if (progressEl) progressEl.style.transform = 'scaleX(' + progress + ')';
    parallaxUpdates.forEach(function (update) {
      update.image.style.transform = 'scale(1.08) translate3d(0, ' + update.translate + 'px, 0)';
    });
  }

  function scheduleScrollFrame() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateScrollFrame);
  }

  if (parallaxRecords.length && canObserveParallax) {
    var parallaxIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        parallaxRecords.forEach(function (record) {
          if (record.element === entry.target) record.visible = entry.isIntersecting;
        });
      });
      scheduleScrollFrame();
    }, { rootMargin: '200px 0px' });
    parallaxRecords.forEach(function (record) { parallaxIO.observe(record.element); });
  }

  if (nav || heroScrollCue || floatBtn || progressEl || parallaxRecords.length) {
    window.addEventListener('scroll', scheduleScrollFrame, { passive: true });
    scheduleScrollFrame();
  }

  // ---------- Mobile drawer ----------
  var burger = root.querySelector('[data-cb-burger]');
  var drawer = root.querySelector('[data-cb-drawer]');
  var drawerClose = root.querySelector('[data-cb-drawer-close]');
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (burger) burger.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawer) {
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) closeDrawer();
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', closeDrawer);
    });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ---------- Magnetic buttons ----------
  if (!prefersReduce && window.matchMedia('(hover: hover)').matches) {
    var magnets = root.querySelectorAll('[data-cb-magnet]');
    magnets.forEach(function (btn) {
      var rect, raf;
      function move(e) {
        if (!rect) rect = btn.getBoundingClientRect();
        var dx = e.clientX - (rect.left + rect.width / 2);
        var dy = e.clientY - (rect.top + rect.height / 2);
        var max = 8;
        var x = Math.max(-max, Math.min(max, dx * 0.18));
        var y = Math.max(-max, Math.min(max, dy * 0.22));
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          btn.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
        });
      }
      btn.addEventListener('mouseenter', function () { rect = btn.getBoundingClientRect(); });
      btn.addEventListener('mousemove', move);
      btn.addEventListener('mouseleave', function () {
        cancelAnimationFrame(raf);
        rect = null;
        btn.style.transform = '';
      });
    });
  }

  // ---------- Number counters ----------
  var counters = root.querySelectorAll('[data-cb-counter]');
  if (counters.length && 'IntersectionObserver' in window) {
    var fmt = function (n) { return n.toLocaleString('es-CL'); };
    var animateCounter = function (el) {
      var target = parseInt(el.getAttribute('data-cb-target'), 10) || 0;
      var suffix = el.getAttribute('data-cb-suffix') || '';
      var valEl = el.querySelector('.cb-numbers__val');
      if (!valEl) return;
      if (prefersReduce) { valEl.textContent = fmt(target) + suffix; return; }
      var dur = 1800;
      var start = performance.now();
      function step(t) {
        var p = Math.min(1, (t - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        valEl.textContent = fmt(Math.round(target * eased)) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    };
    var counterIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          animateCounter(e.target);
          counterIO.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    counters.forEach(function (c) { counterIO.observe(c); });
  }

  // ---------- FAQ exclusive ----------
  var faqList = root.querySelector('[data-cb-faq]');
  if (faqList) {
    var details = faqList.querySelectorAll('details');
    details.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          details.forEach(function (other) {
            if (other !== d && other.open) other.open = false;
          });
        }
      });
    });
  }

  // ---------- Editorial menu · hover swap ----------
  var treatList = root.querySelector('[data-cb-treat-list]');
  if (treatList) {
    var rows = treatList.querySelectorAll('[data-cb-treat]');
    var panes = root.querySelectorAll('[data-cb-pane-img]');
    function activateTreat(targetKey) {
      rows.forEach(function (r) {
        r.classList.toggle('is-active', r.getAttribute('data-cb-pane') === targetKey);
      });
      panes.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-cb-pane-img') === targetKey);
      });
    }
    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        var key = row.getAttribute('data-cb-pane');
        if (key) activateTreat(key);
      });
      row.addEventListener('focusin', function () {
        var key = row.getAttribute('data-cb-pane');
        if (key) activateTreat(key);
      });
    });
  }

  // ---------- Lazy-mount Google Maps iframes (no descargan hasta entrar viewport) ----------
  var lazyMaps = root.querySelectorAll('[data-cb-lazy-map]');
  if (lazyMaps.length) {
    function mountMap(item) {
      if (item.dataset.cbMounted === '1') return;
      var src = item.getAttribute('data-cb-map-src');
      var title = item.getAttribute('data-cb-map-title') || 'Mapa Cara Bonita';
      if (!src) return;
      var iframe = document.createElement('iframe');
      iframe.className = 'cb-loc__map-iframe';
      iframe.loading = 'lazy';
      iframe.referrerPolicy = 'no-referrer-when-downgrade';
      iframe.title = title;
      iframe.src = src;
      var skeleton = item.querySelector('.cb-loc__map-skeleton');
      item.insertBefore(iframe, skeleton || item.firstChild);
      iframe.addEventListener('load', function () {
        item.classList.add('is-loaded');
      }, { once: true });
      item.dataset.cbMounted = '1';
    }
    if ('IntersectionObserver' in window) {
      var mapIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            mountMap(e.target);
            mapIO.unobserve(e.target);
          }
        });
      }, { rootMargin: '300px 0px' });
      lazyMaps.forEach(function (m) { mapIO.observe(m); });
    } else {
      // Fallback: mount all immediately on legacy browsers
      lazyMaps.forEach(mountMap);
    }
  }

  // ---------- Smooth in-page anchors ----------
  root.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href');
      if (!id || id.length < 2) return;
      var target = document.querySelector(id);
      if (!target) return;
      e.preventDefault();
      var navH = nav ? nav.offsetHeight : 0;
      var top = target.getBoundingClientRect().top + window.pageYOffset - navH - 12;
      window.scrollTo({ top: top, behavior: prefersReduce ? 'auto' : 'smooth' });
    });
  });

  // ---------- Treatments page · Interactive concern selector ----------
  if (isTreatments) {
    var concernBtns = root.querySelectorAll('[data-cb-concern]');
    var treatmentCards = root.querySelectorAll('[data-cb-treatment]');
    var catalog = root.querySelector('[data-cb-catalog]');
    var clearBtn = root.querySelector('[data-cb-concern-clear]');
    var filterStatus = root.querySelector('[data-cb-filter-status]');

    function clearHighlights() {
      concernBtns.forEach(function (b) { b.classList.remove('is-active'); });
      treatmentCards.forEach(function (c) {
        c.classList.remove('is-highlight');
        c.classList.remove('is-dim');
      });
      if (filterStatus) filterStatus.textContent = '';
      if (clearBtn) clearBtn.classList.remove('is-visible');
      root.removeAttribute('data-cb-filtered');
    }

    function applyConcern(btn) {
      var matches = (btn.getAttribute('data-cb-match') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var label = btn.querySelector('.cb-trpg-concern__label');
      var concernText = label ? label.textContent.trim() : btn.getAttribute('data-cb-concern');

      // Toggle off if same active button
      if (btn.classList.contains('is-active')) {
        clearHighlights();
        return;
      }

      concernBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      root.setAttribute('data-cb-filtered', 'true');

      var matchedCount = 0;
      treatmentCards.forEach(function (c) {
        var key = c.getAttribute('data-cb-treatment');
        if (matches.indexOf(key) !== -1) {
          c.classList.add('is-highlight');
          c.classList.remove('is-dim');
          matchedCount++;
        } else {
          c.classList.remove('is-highlight');
          c.classList.add('is-dim');
        }
      });

      if (filterStatus) {
        filterStatus.textContent = matchedCount + ' tratamiento' + (matchedCount === 1 ? '' : 's') + ' para “' + concernText + '”';
      }
      if (clearBtn) clearBtn.classList.add('is-visible');

      // Scroll to catalog smoothly
      if (catalog) {
        var navH2 = nav ? nav.offsetHeight : 0;
        var top = catalog.getBoundingClientRect().top + window.pageYOffset - navH2 - 24;
        window.scrollTo({ top: top, behavior: prefersReduce ? 'auto' : 'smooth' });
      }
    }

    concernBtns.forEach(function (b) {
      b.addEventListener('click', function () { applyConcern(b); });
    });
    if (clearBtn) clearBtn.addEventListener('click', clearHighlights);

    // Highlight card briefly when arriving via anchor (e.g. footer link "#botox")
    function pulseCardFromHash() {
      var h = window.location.hash;
      if (!h || h.length < 2) return;
      var key = h.slice(1);
      var card = root.querySelector('[data-cb-treatment="' + key + '"]');
      if (!card) return;
      card.classList.add('is-pulse');
      setTimeout(function () { card.classList.remove('is-pulse'); }, 2400);
    }
    if (window.location.hash) {
      // Wait a tick so anchor scroll completes
      setTimeout(pulseCardFromHash, 400);
    }
    window.addEventListener('hashchange', pulseCardFromHash);
  }

})();
